<template>
  <el-dialog title="wifi分佣设置" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="昵称" :label-width="formLabelWidth">
        <el-input v-model="form.nickname" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人ID" :label-width="formLabelWidth">
        <el-input v-model="form.inviteId" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人昵称" :label-width="formLabelWidth">
        <el-input v-model="form.inviteName" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="分佣(%)" :label-width="formLabelWidth">
        <el-input-number v-model="form.wifiRate" autocomplete="off"></el-input-number>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false
      }
    },
    props: ['open_edit', 'form'],
    created() {

      this.dialogVisible = this.open_edit;
      this.form.wifiRate = JSON.parse(this.form.wifiSetting).wifiRate
    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        params.wifiSetting = {
          wifiRate: self.form.wifiRate
        }
        UserApi.userWifiSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: 'wifi分佣设置成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      }

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/WifiSetting.vue